module.exports = __webpack_public_path__ + "static/media/saptari2.bd3fe1fb.ogg";